import styled from 'styled-components'

const SzambelanStyle = styled.section`
  margin: auto;
  height: 756px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${props => props.theme.black4};

  h2 {
    width: 370px;
    text-align: center;
  }

  h1 {
    font-size: 36px;
    color: ${props => props.theme.black60};
    margin-bottom: 12px;
    text-align: center;
  }

  p {
    color: ${props => props.theme.black38};
    font-size: 24px;
  }
`
export default SzambelanStyle
